import { createFileRoute, Outlet, useParams } from "@tanstack/react-router"
import { OrgShell } from "@/components/org/OrgShell"
import { requireSession } from "@/lib/auth-guard"

// Layout for the org settings sections. The chrome — header, left nav,
// active-org resolution — now lives in OrgShell, shared with the tenant home,
// so Events / Members & invites / Settings sit in ONE sidebar rather than the
// events list having a lone "Settings" button and settings having a nav of its
// own. This route is just the mount point for the settings children.
export const Route = createFileRoute("/$orgSlug/settings")({
  beforeLoad: async ({ location, context }) => {
    const user = await requireSession(location.href)
    context.queryClient.setQueryData(["session", "me"], user)
    return { user }
  },
  component: OrgSettingsLayout,
})

function OrgSettingsLayout() {
  const params = useParams({ from: "/$orgSlug/settings" })
  return (
    <OrgShell orgSlug={params.orgSlug}>
      <Outlet />
    </OrgShell>
  )
}
